module.exports = __webpack_public_path__ + "img/3.4_Russian_road_sign.bafc1333.svg";